import { styled } from 'goober';
export var MissingTagsHeader = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
    });
});
export var MissingTagsHeaderItem = styled('div')(function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return ({
        color: $active ? theme.colors.ui.white : theme.colors.neutral.w700,
        backgroundColor: $active ? theme.colors.primary.w500 : theme.colors.ui.white,
        padding: '10px 20px',
        flexGrow: 1,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: $active ? theme.colors.primary.w500 : theme.borderColor,
        borderRightStyle: 'none',
        cursor: 'pointer',
        '&:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },
        '&:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
            borderRightStyle: 'solid',
        },
    });
});
export var MissingTagsBox = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        marginTop: '20px',
    });
});
export var MissingTagsListRow = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        '> :nth-child(1)': {
            // checkbox
            width: '90px',
        },
        '> :nth-child(2)': {
            // name
            width: '140px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '> :nth-child(3)': {
            // description input
            width: '250px',
        },
        '> :nth-child(4)': {
            // connected Tags
            width: '300px',
        },
    });
});
